import React, { Component } from "react";
import { Form } from "react-bootstrap";
import { Button, Paper, Box, Typography } from "@mui/material";
import { VpnKey, Email, Check } from "@mui/icons-material";

import LocationReader from '../managers/LocationReader';
import ClientAPI from "../service/ClientAPI";

class ResetPasswordPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            token: LocationReader.ReadParameter("id", props.location.search)
        }
    }

    SetNewPassword = (ev) => {
        ev.preventDefault();

        const _inputs = ev.target,
            _password = _inputs.pwd.value,
            _passwordRepeat = _inputs.pwdrepeat.value,
            _email = _inputs.email.value;

        ClientAPI.SetNewPassword({
            passwordRepeat: _passwordRepeat,
            password: _password,
            email: _email,
            token: this.state.token
        })
            .then((_res) => {
                window.location.replace("/");
            });
    }

    render() {
        return (
            <div style={{ 
                minHeight: "80vh", 
                maxWidth: window.innerWidth < 600 ? "95%" : "80%", 
                margin: "auto", 
                marginTop: window.innerWidth < 600 ? "20px" : "40px", 
                paddingBottom: window.innerWidth < 600 ? "40px" : "60px" 
            }}>
                <Typography 
                    variant="h3" 
                    sx={{ 
                        textAlign: "center", 
                        mb: { xs: 3, sm: 4 },
                        fontWeight: 700,
                        color: "#2e7d32",
                        fontSize: { xs: '1.75rem', sm: '2.5rem', md: '3rem' }
                    }}
                >
                    Passwort zurücksetzen
                </Typography>

                <Paper
                    elevation={3}
                    sx={{
                        maxWidth: "600px",
                        margin: "auto",
                        borderRadius: { xs: '12px', sm: '20px' },
                        overflow: 'hidden',
                        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)"
                    }}
                >
                    {/* Header with gradient */}
                    <Box
                        sx={{
                            background: 'linear-gradient(135deg, #2e7d32 0%, #66bb6a 100%)',
                            p: { xs: 2, sm: 3 },
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            gap: { xs: 1.5, sm: 2 }
                        }}
                    >
                        <VpnKey sx={{ fontSize: { xs: '1.5rem', sm: '2rem' } }} />
                        <Typography variant="h5" sx={{ fontWeight: 600, fontSize: { xs: '1.1rem', sm: '1.5rem' } }}>
                            Neues Passwort festlegen
                        </Typography>
                    </Box>

                    <Box sx={{ p: { xs: 2.5, sm: 4 } }}>
                        <Form onSubmit={this.SetNewPassword}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label style={{ fontWeight: 600, color: '#333', marginBottom: '8px' }}>
                                        E-Mail
                                    </Form.Label>
                                    <Form.Control 
                                        type="email" 
                                        name="email" 
                                        placeholder="E-Mail eingeben" 
                                        onChange={this.handleChange}
                                        style={{
                                            borderRadius: '10px',
                                            padding: '12px',
                                            border: '2px solid #e0e0e0',
                                            fontSize: '1rem'
                                        }}
                                    />
                                </Form.Group>

                                <Form.Group controlId="formBasicPassword">
                                    <Form.Label style={{ fontWeight: 600, color: '#333', marginBottom: '8px' }}>
                                        Neues Passwort
                                    </Form.Label>
                                    <Form.Control 
                                        type="password" 
                                        name="pwd" 
                                        placeholder="Neues Passwort eingeben" 
                                        onChange={this.handleChange}
                                        style={{
                                            borderRadius: '10px',
                                            padding: '12px',
                                            border: '2px solid #e0e0e0',
                                            fontSize: '1rem'
                                        }}
                                    />
                                </Form.Group>

                                <Form.Group controlId="formBasicRepeatPassword">
                                    <Form.Label style={{ fontWeight: 600, color: '#333', marginBottom: '8px' }}>
                                        Passwort wiederholen
                                    </Form.Label>
                                    <Form.Control 
                                        type="password" 
                                        name="pwdrepeat" 
                                        placeholder="Passwort bestätigen" 
                                        onChange={this.handleChange}
                                        style={{
                                            borderRadius: '10px',
                                            padding: '12px',
                                            border: '2px solid #e0e0e0',
                                            fontSize: '1rem'
                                        }}
                                    />
                                </Form.Group>

                                <Button 
                                    type="submit" 
                                    variant="contained"
                                    startIcon={<Check />}
                                    fullWidth
                                    sx={{
                                        bgcolor: '#2e7d32',
                                        color: 'white',
                                        fontWeight: 600,
                                        textTransform: 'none',
                                        fontSize: { xs: '0.95rem', sm: '1.1rem' },
                                        py: { xs: 1.3, sm: 1.5 },
                                        borderRadius: '10px',
                                        mt: 2,
                                        boxShadow: '0 4px 12px rgba(46, 125, 50, 0.3)',
                                        '&:hover': {
                                            bgcolor: '#1b5e20',
                                            boxShadow: '0 6px 16px rgba(46, 125, 50, 0.4)',
                                            transform: 'translateY(-2px)'
                                        },
                                        transition: 'all 0.2s ease'
                                    }}
                                >
                                    Passwort bestätigen
                                </Button>
                            </Box>
                        </Form>
                    </Box>
                </Paper>
            </div>
        )
    }
}

export default ResetPasswordPage;